import { NgModule } from "@angular/core";

import { LogoutComponent } from "../logout/logout.component";

@NgModule({
  declarations: [LogoutComponent],
  imports: [],
})
export class LogoutModule {}
